<div class="main">
    <app-toast #toast></app-toast>
    <app-session-countdown></app-session-countdown>
    <ng-container *ngIf="userInfo; else waiting">
        <!-- SIDEBAR -->
        <div class="sidebar">
            <app-sidebar *ngIf="innerWidth && innerWidth > 1000; else navbar"></app-sidebar>
            <ng-template #navbar>
                <app-navbar></app-navbar>
            </ng-template>
        </div>
        <!-- SIDEBAR -->
        <div class="body">
            <router-outlet></router-outlet>
        </div>
    </ng-container>
    <ng-template #waiting>
        <app-loading></app-loading>
    </ng-template>
</div>

<!-- <div *ngIf="innerWidth! <= 767" class="break" style="margin-bottom: 10px;"></div> -->